import { render, staticRenderFns } from "./PlayerGvntsTable.vue?vue&type=template&id=0b7299fe&scoped=true&"
import script from "./PlayerGvntsTable.vue?vue&type=script&lang=js&"
export * from "./PlayerGvntsTable.vue?vue&type=script&lang=js&"
import style0 from "./PlayerGvntsTable.vue?vue&type=style&index=0&id=0b7299fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7299fe",
  null
  
)

export default component.exports